import DataSourceSavingView from '../data-source-saving-view'
import template from './rest-data-selector.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import $ from 'jquery'
import RestCommunicationDetails from './rest-communication-details'
import appDisplay from '../../components/app-display'
import Cleaver from 'cleaver'
import _ from 'lodash'

const RestDataSelector = DataSourceSavingView.extend(/** @lends {RestDataSelector} */{

	tagName: 'form',

	className: 'rest-data-selector',

	events: {
		'click .communication-details': 'onClickCommunicationDetails',
	},

	/**
	 * View for selecting the data to import from a REST web service
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Importable} options.model
	 *
	 * @param {Wizard} options.wizard the wizard this rest request is a part
	 * of
	 *
	 * @param {Object} options.labels singular and plural labels for the type
	 * of data being imported
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			test: this.test.bind(this),
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.html(template(this.context()))
		this.renderCleaver()
		// Tell the dialog to fill up the entire height of the screen
		this.fillHeight = true
		this.options.wizard?.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		this.formView.start()
		return this
	},

	renderCleaver: function() {
		let wsResponse = this.model?.get('dataSourceMetadata')?.restMetadata?.wsResponse
		if (_.isEmpty(wsResponse)) return

		let data = JSON.parse(wsResponse)
		data = limitArrayItems(data)

		this.cleaver = new Cleaver()
		this.cleaver.render(this.$('.cleaver-container')[0], data)
		let jsonPath = this.model?.get('dataSourceMetadata')?.restMetadata?.path
		this.cleaver.setPath(jsonToCleaverPath(jsonPath))
		this.cleaver.on('change', () => this.formView.change())
	},

	context: function() {
		let title = i18n.get('admin.import.datasource.from.rest',
			this.options?.labels?.plural)
		return {
			title,
			banner: this.banner(this.model?.get('type'))
		}
	},

	banner: function(type) {
		return `admin.importConnections.web-service.rest.data.${type}`
	},

	onClickCommunicationDetails: function() {
		appDisplay.dialog(new RestCommunicationDetails({
			model: this.model
		}))
	},

	saveState: function() {
		let dsm = this.model.attributes.dataSourceMetadata
		if (dsm.restMetadata == null) {
			dsm.restMetadata = {}
		}
		dsm.restMetadata.path = cleaverToJsonPath(this.cleaver.getPath())
	},

	test: function() {
		if (_.isEmpty(this.cleaver?.getPath?.())) {
			return i18n.get('admin.import.datasource.from.rest.responseBody.required')
		}
	},

	submit: function() {
		this.saveState()
		const data = _.cloneDeep(this.model.attributes)

		// if this is a new dataset, then it will only have field properties if
		// we already selected them in this dialogue so clear out the existing
		// data to start new here
		if (data.type == 'dataset' && _.isNil(data.id)) {
			delete data.dataSourceMetadata?.fields
			delete data.dataSourceMetadata?.automaticFieldsByIntermediateColumn
		}

		return $.ajax({
			method: 'post',
			data: JSON.stringify(data),
			url: this.model.urlRoot + '/load-rest-data',
			success: this.success.bind(this),
			error: xhr => this.formView.error(xhr)
		})
	},

	autoRemove: true

})

function cleaverToJsonPath(cleaverPath) {
	return _(cleaverPath)
		.map(path => {
			if (['$','*'].includes(path)) return path
			return `['${path}']`
		})
		.join('.')
}

function jsonToCleaverPath(jsonPath) {
	const pathArray = []
	if (_.isEmpty(jsonPath)) return pathArray

	let pathSegment = ''
	let inBracket = false
	for (let i = 0; i < jsonPath.length; i++) {
		const char = jsonPath[i]
		const isFirstChar = i == 0
		const isLastChar = i == jsonPath.length - 1
		const wrappingApos = isFirstChar || isLastChar ? false :
			(jsonPath[i - 1] == '[' || jsonPath[i + 1] == ']') && char === '\''

		if (_.includes(['$', '*'], char) && !inBracket) {
			pathArray.push(char)
		} else if ((char === '.' && !inBracket) || wrappingApos) {
			// don't include periods outside of brackets or wrapping apostrophes
		} else if (char === '[' && (isFirstChar || isLastChar || jsonPath[i + 1] == '\'')) {
			inBracket = true
		} else if (char === ']' && (isFirstChar || isLastChar || jsonPath[i - 1] == '\'')) {
			inBracket = false
			if (pathSegment !== '') {
				pathArray.push(pathSegment)
				pathSegment = ''
			}
		} else {
			pathSegment += char
		}
	}

	if (pathSegment !== '') {
		pathArray.push(pathSegment)
	}

	return pathArray
}

function limitArrayItems(obj) {
	if (typeof obj === 'object' && obj !== null) {
		if (Array.isArray(obj)) {
			return obj.slice(0, 10).map(limitArrayItems)
		} else {
			for (const key in obj) {
				if (obj.hasOwnProperty(key)) {
					obj[key] = limitArrayItems(obj[key])
				}
			}
		}
	}
	return obj
}

_.extend(RestDataSelector, {
	cleaverToJsonPath,
	jsonToCleaverPath,
	limitArrayItems
})
export default RestDataSelector
export { cleaverToJsonPath }
export { jsonToCleaverPath }
export { limitArrayItems }

RestDataSelector.__filename__ = 'imports/rest/rest-data-selector.js'
